
    import "src/shared/components/ColorPicker/index.module.scss?farm_css_modules";
    
    export default {"colorPickerDiv": `colorPickerDiv-c363ce5e`,"colorPickerParentDiv": `colorPickerParentDiv-c363ce5e`}
    